import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { LayoutDashboard, UserPlus, Calendar, CalendarDays, Trophy, FileText, MessageCircle, ClipboardCheck, HelpCircle } from 'lucide-react';

const Navigation = ({ active }) => {
  const navigate = useNavigate();
  const [showLancar, setShowLancar] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) setShowLancar(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleLancar = (path) => {
    setShowLancar(false);
    navigate(path);
  };

  const navItems = [
    { icon: LayoutDashboard, label: 'Início', path: '/dashboard', key: 'dashboard' },
    { icon: UserPlus, label: 'Cadastrar', path: '/cadastro', key: 'cadastro' },
    { icon: Calendar, label: 'Lançar', path: null, key: 'lancamento' },
    { icon: ClipboardCheck, label: 'Escalas', path: '/escalas', key: 'escalas' },
    { icon: Trophy, label: 'Ranking', path: '/ranking', key: 'ranking' },
    { icon: FileText, label: 'Relatórios', path: '/relatorios', key: 'relatorios' },
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50">
      {/* FABs - Fale Conosco + Ajuda */}
      <div className="absolute -top-14 right-4 flex gap-2">
        <button
          data-testid="nav-ajuda"
          onClick={() => navigate('/ajuda')}
          className="bg-amber-500 hover:bg-amber-600 text-white rounded-full w-12 h-12 shadow-lg flex items-center justify-center active:scale-95 transition-all"
          title="Ajuda"
        >
          <HelpCircle className="w-5 h-5" />
        </button>
        <button
          data-testid="nav-fale-conosco"
          onClick={() => navigate('/fale-conosco')}
          className="bg-[#1A4D2E] hover:bg-[#145A32] text-white rounded-full w-12 h-12 shadow-lg flex items-center justify-center active:scale-95 transition-all"
          title="Fale Conosco"
        >
          <MessageCircle className="w-5 h-5" />
        </button>
      </div>
      <div className="bg-white border-t border-gray-200 shadow-2xl">
      <div className="max-w-5xl mx-auto px-2">
        <div className="grid grid-cols-6 gap-1">
          {navItems.map((item) => {
            const isActive = active === item.key;
            const isLancar = item.key === 'lancamento';

            return (
              <div key={item.key} className="relative" ref={isLancar ? menuRef : null}>
                {isLancar && showLancar && (
                  <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 bg-white rounded-xl shadow-xl border border-gray-200 overflow-hidden min-w-[160px] animate-in fade-in slide-in-from-bottom-2 duration-200">
                    <button
                      data-testid="nav-lancar-semanal"
                      onClick={() => handleLancar('/lancamento/semanal')}
                      className="w-full flex items-center gap-3 px-4 py-3 hover:bg-[#F2F7F4] transition-colors text-left"
                    >
                      <CalendarDays className="w-4 h-4 text-[#1A4D2E]" />
                      <span className="text-sm font-inter font-semibold text-[#1A4D2E]">Semanal</span>
                    </button>
                  </div>
                )}
                <button
                  data-testid={`nav-${item.key}`}
                  onClick={() => isLancar ? setShowLancar(!showLancar) : navigate(item.path)}
                  className={`w-full flex flex-col items-center justify-center py-3 transition-all duration-300 ${
                    isActive ? 'text-[#1A4D2E]' : 'text-gray-400 hover:text-gray-600'
                  }`}
                >
                  <item.icon
                    className={`w-6 h-6 mb-1 transition-all duration-300 ${isActive ? 'scale-110' : 'scale-100'}`}
                    strokeWidth={isActive ? 2.5 : 2}
                  />
                  <span className={`text-xs font-inter ${isActive ? 'font-semibold' : 'font-normal'}`}>
                    {item.label}
                  </span>
                  {isActive && <div className="w-8 h-1 bg-[#1A4D2E] rounded-full mt-1" />}
                </button>
              </div>
            );
          })}
        </div>
      </div>
      </div>
      <div className="text-center py-2 border-t border-gray-100">
        <p className="text-[10px] text-white">&copy; 2026 KingdomCloud.com.br. Todos os direitos reservados.</p>
      </div>
    </nav>
  );
};

export default Navigation;
